<template>
  <div :class="className">
    <slot />
    <v-sheet class="mt-1" color="secondary" height="4px" width="75px"></v-sheet>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    className() {
      const alignClass = {
        left: "text-left align-start",
        center: "text-center align-center",
        right: "text-right align-end",
      };

      const className = [
        "d-flex flex-column justify-center flex-column font-weight-bold title-widget",
        alignClass[this.align],
        !this.dark ? "primary--text" : "white--text",
        !this.small && "text-h5 text-md-h4",
      ];

      return className;
    },
  },
};
</script>
